import xs from "xstream"
import sampleCombine from "xstream/extra/sampleCombine"
import isolate from "@cycle/isolate"
import * as R from "ramda"

import {PAGE, STATE_KEY, MAGAZINE_URL, API} from '../../../constant'
// import {MemberType, MessageType} from '../../../interface'

import {pageViewTempl, apiOK, getMemberType, fmtMember} from '../../common'
import {createApiReq, createApiResp, createApiReqEx} from '../../common'

import {view} from './view'
import { MemberType, MessageInfo, TARGET_FLAG_MAP, MessageStatus, MessageTarget} from "../../../interface"

const messageAllReq = createApiReq("messageAll", "GET");
const messageAllResp = createApiResp("messageAll");
const messageReq = createApiReqEx("message");
const messageResp = createApiResp("message");
const photoListReq = createApiReqEx("photoList")
const photoListResp = createApiResp("photoList")

const isViewerble = (type: MemberType) => {
	const chkBit = R.prop(type, TARGET_FLAG_MAP)
	const now = (new Date()).getTime()
	return ({target, status, startDate, endDate}: MessageInfo) => {
		return ((target & chkBit) === chkBit)
			&& (status === MessageStatus.Show)
			&& (startDate <= now && now <= endDate)
	}
}

const isMemberMessage = (user: any) => ({target, status, startDate, endDate, memberIds}: MessageInfo) => {
	if (target != MessageTarget.MemberIds) {
		return false
	}
	const memberId = fmtMember(user.id)
	const hasUser = R.includes(memberId, memberIds.split(/\r*\n/))
	const now = (new Date()).getTime()
	return hasUser
		&& (status === MessageStatus.Show)
		&& (startDate <= now && now <= endDate)
}

const messageSort = R.sortWith([
	R.descend(R.prop("viewWeight")),
	R.descend(R.prop("startDate")),
	R.descend(R.prop("type")),
])

const MemberId = sources => {
	const user$ = sources.state.select([STATE_KEY.User])
	const config$ = sources.state.select([STATE_KEY.Config])
  const receipts$: xs<any[]> = sources.state.select(["receipts"])
    .map((receipts: any) => {
      if (!receipts) return []
      return R.uniq(R.pluck("receiptDate", receipts))
    })
  const loading$ = sources.receiptDownload
	// const memberType$ = sources.state.select([STATE_KEY.Memberships])
	// 	.map(toJS)
	const memberType$ = user$
		.map(R.propOr([], "members"))
		.map(getMemberType)
	
	const home$ = sources.DOM.select(".btnHome").events("click")
		.mapTo("/member/top")


	const scrollTop$ = xs.of("scrollTop").debug(() => window.scroll(0, 0))

  const initReq$ = user$.map((user: any) => 
    xs.fromArray([
      messageAllReq(),
      messageReq({
        url: API["message"](R.prop("id", user)),
        method: "GET"
      }),
      photoListReq({
        url: API["photoList"](fmtMember(R.prop("id", user))),
        method: "GET"
      }),
    ])
  )
  .flatten()

	const privateMsg$ = messageResp(sources.HTTP)
		.filter(apiOK)
		.map(R.path(["data", "Item", "message"]))
		.startWith(null)


	const messagesResp$ = messageAllResp(sources.HTTP)
		.filter(apiOK)
		.map(R.path(["data", "Item", "data"]))
		.startWith([])
	
	const publicMsg$ = messagesResp$
		.compose(sampleCombine(memberType$))
		.map(([messages, memberType]: [MessageInfo[], MemberType]) => {
			return R.filter(isViewerble(memberType), R.defaultTo([], messages))
		})

	const privateMsg2$ = messagesResp$
		.compose(sampleCombine(user$))
		.map(([messages,user]: [MessageInfo[], any]) => {
			if (!user || !messages) return []
			return R.filter(isMemberMessage(user), messages)
		})

	const messages$ = publicMsg$
		.compose(sampleCombine(privateMsg2$))
		.map(([publicMsg, privateMsg2]) => {
			return messageSort(R.concat(publicMsg, privateMsg2))
		})

	const password$ = sources.DOM.select(".btnPassword2").events("click")
		.mapTo("/member/password")
	const profile$ = sources.DOM.select(".btnProfile").events("click")
		.mapTo("/member/profile")

	const logout$ = sources.DOM.select(".btnLogout2").events("click")
		.mapTo("/loading")

	const magazine$ = sources.DOM.select(".btnMagazine").events("click")
		.mapTo({href: MAGAZINE_URL, target: "_blank"})

	const btnUpload$ = sources.DOM.select(".btnUpload").events("click")
		.mapTo("/member/photo")

  const photoUpload$ = photoListResp(sources.HTTP)
		.filter(apiOK)
    .map(R.path(["data", "Contents", "length"]))
    .startWith(0)

  const receiptLink$ = sources.DOM.select(".receiptLink > div").events("click")
    .map(R.path(["target", "dataset", "id"]))
    .compose(sampleCombine(user$))
    .map(([date, user]: [string, any]) => {
      return {
        date, id: fmtMember(R.prop("id", user))
      }
    })

	const view$ = view(config$, user$, messages$, privateMsg$, photoUpload$, receipts$)
	const pageView = pageViewTempl(PAGE.Top.id, xs.never(), "WEB会員証")
	return {
		HTTP: xs.merge(initReq$),
		DOM: pageView(view$),
		router: xs.merge(home$, profile$, logout$, btnUpload$),
		externalLink: xs.merge(magazine$),
		dumper: xs.merge(privateMsg2$, privateMsg$),
    receiptDownload: receiptLink$,
    loading: loading$,
	}
}
export default isolate(MemberId)
